module.exports = __webpack_public_path__ + "img/材料力学7_3_2.d37044e1.jpg";